import React, { useRef } from "react";
import { Carousel } from "antd";
import Fade from "react-reveal/Fade";
import texts from "../../texts.json";

import "./style.css";

import image1 from "../../images/img-01.jpg";
import image2 from "../../images/img-02.jpg";
import image3 from "../../images/img-03.jpg";
import gfBackground from "../../images/faixa.png";

const AboutUsComponent = (props) => {
  const ref = useRef();
  const index = props.index;

  return (
    <div className="section about-us" id="story">
      <div className="gf-bg bg-about">
        <img src={gfBackground}  alt="" />
      </div>
      <div className="section-title">
        <div>{texts.titles.historia[index]}</div>
        <Fade left big>
          <div className="line-one-sub"></div>
        </Fade>
        <Fade right big>
          <div className="line-two-sub"></div>
        </Fade>
      </div>

      <Fade>
        <div className="section-content">
          <Carousel ref={ref} effect="fade">
            <div className="carousel-content">
              <p className="carousel-text">{texts.story.slide1[index]}</p>
              <img
                alt="Marble Slider"
                src={image1}
                className="carousel-image"
              />
            </div>

            <div className="carousel-content">
              <p className="carousel-text">{texts.story.slide2[index]}</p>
              <img
                alt="Marble Slider"
                src={image2}
                className="carousel-image"
              />
            </div>

            <div className="carousel-content">
              <p className="carousel-text">{texts.story.slide3[index]}</p>
              <img
                alt="Marble Slider"
                src={image3}
                className="carousel-image"
              />
            </div>
          </Carousel>
        </div>
      </Fade>
    </div>
  );
};

export default AboutUsComponent;
